import { Bar } from 'react-chartjs-2'
import { colorPalette } from '../../utils/color-utils'

export default function ChartTypeY({ data, title, label }: any) {
    const labels = data.map((item: any) => item.type)

    const datasets = [
        {
            label: label,
            data: data.map((item: any) => item.sum),
            borderWidth: 2,
            datalabels: {
                color: colorPalette[0],
            },
        },
    ]

    const options = {
        indexAxis: "y",
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: false,
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Bar data={{ labels, datasets }} options={options} />
    )
}
